import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/lib/Collapse';
import ItemWrapper from './ItemWrapper';
import Title from './Title';
import {TPSlider} from 'components/FormComponents';
import {formatPrice} from 'lib/helpers/globalize-helper';

class PriceRange extends Component {
  state = {
    show: true
  };

  toggleFilter = () => this.setState((prevState) => ({show: !prevState.show}));

  render() {
    const {show} = this.state;
    const {price, updatePriceValue, resetPriceValue, currency, translations, onPriceChange} = this.props;
    const {priceRange, maxPrice, reset} = translations;
    return (
      <ItemWrapper>
        <Title
          title={priceRange}
          isOpen={show}
          onClick={this.toggleFilter}
        />
        <Collapse in={show}>
          <div className="filter-content">
            <TPSlider
              withIndicators={true}
              label={maxPrice}
              resetBtn={{
                displayReset: Boolean(price.value ? price.value < price.max : false),
                resetLabel: reset,
                onReset: resetPriceValue
              }}
              min={price.min}
              max={price.max}
              defaultValue={price.max}
              marks={{
                [price.min]: <span>{formatPrice(price.min, currency)}</span>,
                [price.max]: <span>{formatPrice(price.value || price.max, currency)}</span>
              }}
              onChange={updatePriceValue}
              onAfterChange={onPriceChange}
              value={price.value || price.max}
            />
          </div>
        </Collapse>
      </ItemWrapper>
    );
  }
}

PriceRange.propTypes = {
  currency: PropTypes.string.isRequired,
  price: PropTypes.shape({
    defaultValue: PropTypes.number,
    value: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number
  }),
  updatePriceValue: PropTypes.func.isRequired,
  resetPriceValue: PropTypes.func.isRequired,
  onPriceChange: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    priceRange: PropTypes.string.isRequired,
    maxPrice: PropTypes.string.isRequired,
    reset: PropTypes.string.isRequired
  })
};

export default PriceRange;
